async function getStoresData() {
    if (!state.stores) {
        const response = await fetch(APP.STORES_URL);

        const json = await response.json();

        state.stores = json.data;
    }

    if (!state.selectedStoreID) {
        state.selectedStoreID = Object.values(state.stores)[0][0].id;
    }

    updateSelectedStore();

    return state.stores;
}

function updateSelectedStore() {
    state.selectedStore = Object.values(state.stores).flat(1).find(store => store.id === state.selectedStoreID)
}
